module.exports = __webpack_public_path__ + "static/media/female.14917fb4.png";